import {
  CopilotWorkKind,
  type CopilotWorkStartedEventInfo,
} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {CopilotWorkEventText} from './CopilotWorkEventText'
import {formatCopilotWorkSummaryText} from './format-copilot-work-summary-text'

export function CopilotWorkStartedEventText({info}: {info: CopilotWorkStartedEventInfo}) {
  const actionText = info.summary?.trim()
    ? formatCopilotWorkSummaryText(info.summary)
    : info.workKind === CopilotWorkKind.CODING
      ? 'started work'
      : 'started reviewing'

  return <CopilotWorkEventText info={info} actionText={actionText} />
}
